import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'ellipsize' })
export class EllipsizePipe implements PipeTransform {

    transform(value: any, lenght: any): string {
        if (value && lenght > 11) {
            if (value.length > lenght) {
                return value.substr(0, lenght / 2) + '...' + value.substr(value.length - 10, value.length);
            }

            return value;
        }

        return value;
    }
}